<!-- 上1主下2从 合同管理 -->
<template>
  <div>
  <upper1MasterLower4Slave1Sun
    ref="columnTables"
    :zbParams="{
      opId: 3801,
      dataClass : 1,
      // searchHidden: true,   // 是否隐藏顶部搜索
      // topButtonArea: false,   // 是否隐藏顶部按钮
      tableHeight: 450, // 表格高度
      //isTopDelete: true,// 是否隐藏顶部的删除按钮 true隐藏
      //isTopAdd: true,// 是否隐藏顶部的新增按钮 true隐藏
      rowFilesClick,
    }"
    :cbParams="{
      opId: 3801,
      dataClass : 2,
      searchHidden: true,   // 是否隐藏顶部搜索
      //topButtonArea: false,   // 是否隐藏顶部按钮
      tableHeight: 300, // 表格高度
      tzRecClick,//跳转至收款表
    }"
    :cb2Params="{
      opId: 3801,
      dataClass : 3,
      searchHidden: true,   // 是否隐藏顶部搜索
      //topButtonArea: false,   // 是否隐藏顶部按钮
      tableHeight: 300, // 表格高度
    }"
    :cb3Params="{
      opId: 3801,
      dataClass : 4,
      searchHidden: true,   // 是否隐藏顶部搜索
      //topButtonArea: false,   // 是否隐藏顶部按钮
      tableHeight: 300, // 表格高度
    }"
    :cb4Params="{
      opId: 3801,
      dataClass : 5,
      searchHidden: true,   // 是否隐藏顶部搜索
      topButtonArea: true,   // 是否隐藏顶部按钮
      tableHeight: 300, // 表格高度
      isTopDelete: true,// 是否隐藏顶部的删除按钮 true隐藏
      isTopAdd: true,// 是否隐藏顶部的新增按钮 true隐藏
    }"
    :sunParams="{
      opId: 3801,
      dataClass : 6,
      searchHidden: true,   // 是否隐藏顶部搜索
      //topButtonArea: false,   // 是否隐藏顶部按钮
      tableHeight: 300, // 表格高度
    }"
    :zcbGlgx="{
      parProp: 'CONID',
      chilProp: 'CONID',
      chilIDProp: 'CONDTLID',
      chil2Prop: 'CONID',
      chil3Prop: 'CONID',
      chil4Prop: 'CONID',
      chilsunProp: 'CONDTLID',
    }"
    :splitUrl='{
        url:"contractMasterManySlave",
        finderId:3112,
        pinjieId:"CONDTLID",
        field:"CONDTLID",
        viewId:"B_INV_SELECT_TO_REC_V",
      }'
    :tableName="{
      zbTableName: '合同总单',
      cbTableName: '合同细单',
      cb2TableName: '发票',
      cb3TableName: '供应商费用',
      cb4TableName: '利润',
      sunTableName: '收款',
    }"
  >
    <template slot="menuRightSlave" slot-scope="{ row }">
    </template>
  </upper1MasterLower4Slave1Sun>
  <file-dialog :visible.sync="filedialog" :params="fileParams" @isupload="isupload"></file-dialog>
  </div>
</template>
  
  <script>
  import upper1MasterLower4Slave1Sun from "@/components/table/newTemplate/upper1MasterLower4Slave1Sun";
  import FileDialog from '@/components/attachment/attachment';
  export default {
  components: {
    upper1MasterLower4Slave1Sun,
    FileDialog,
  },
  data() {
    return {
      filedialog:false,
      fileParams: {},
    };
  },
  computed: {},
  methods: {
    //
    saveClick(row,button){
      console.log(row,button);
    },
    //跳转至供应商
    async tzGysClick(btn,row) {
      this.$router.push({
        path: '/business/cbs/supplier',
        // 携带的查询参数
        query: {
          runId: this.$route.query.runId,
          CONID:row.CONID,
        }
      });
    },
    //跳转至发票
    async tzInvClick(btn,row) {
      this.$router.push({
        path: '/business/cbs/inv',
        // 携带的查询参数
        query: {
          runId: this.$route.query.runId,
          CONID:row.CONID,
        }
      });
    },
    //跳转至收款表
    async tzRecClick(btn,row) {
      this.$router.push({
        path: '/business/cbs/rec',
        // 携带的查询参数
        query: {
          runId: this.$route.query.runId,
          CONDTLID:row.CONDTLID,
        }
      });
    },
    // 附件
    rowFilesClick(btn, row){
        this.fileParams = {
            businessType: 510,
            businessUsage: '1',
            businessId: row.CONID,
        };
        this.filedialog = true;
    },
    // 上传完成刷新
    isupload(a){
        this.$refs.table.$refs.child.onLoad();
    },
  },
  mounted() {},
  activated() {},
  };
  </script>
  <style lang="scss" scoped>
  </style>

  